module.exports = __webpack_public_path__ + "static/media/China24.d5b03077.jpg";